import { cn } from '../../../shared/utils/cn'

export type UserEditTab = 'profile' | 'groups' | 'manage'

interface UserEditTabsProps {
  activeTab: UserEditTab
  onTabChange: (tab: UserEditTab) => void
  /** Assigned-group count, shown on the Groups tab so access is legible without opening it. */
  groupCount?: number
  /** Tabs holding unsaved edits, marked with a dot so a pending save is not lost behind a tab. */
  dirtyTabs?: UserEditTab[]
}

const TABS: Array<{ id: UserEditTab; name: string }> = [
  { id: 'profile', name: 'Profile' },
  { id: 'groups', name: 'Groups' },
  { id: 'manage', name: 'Manage' },
]

export function UserEditTabs({ activeTab, onTabChange, groupCount, dirtyTabs = [] }: UserEditTabsProps) {
  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="Edit User Tabs">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onTabChange(tab.id)}
              aria-current={isActive ? 'page' : undefined}
              className={cn(
                'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              )}
            >
              {tab.name}
              {tab.id === 'groups' && groupCount !== undefined && (
                <span
                  className={cn(
                    'ml-2 px-2 py-0.5 rounded-full text-xs font-semibold',
                    isActive ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'
                  )}
                >
                  {groupCount}
                </span>
              )}
              {dirtyTabs.includes(tab.id) && (
                <span
                  className="ml-2 inline-block w-2 h-2 rounded-full bg-amber-500 align-middle"
                  aria-label="Unsaved changes"
                  title="Unsaved changes"
                />
              )}
            </button>
          )
        })}
      </nav>
    </div>
  )
}
